import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface ReferralStats {
  clicks: number;
  signups: number;
  paying_referrals: number;
  months_won: number;
}

export interface ReferralHistoryItem {
  id: string;
  date: string;
  amount_cents: number;
  currency: string;
  months: number;
  referred_email: string | null;
}

export interface ReferralData {
  referral_code: string;
  referral_link: string;
  stats: ReferralStats;
  history: ReferralHistoryItem[];
}

export function useReferralMe() {
  const [data, setData] = useState<ReferralData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchReferral();
  }, []);

  async function fetchReferral() {
    setLoading(true);
    setError(null);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        setError('Not authenticated');
        return;
      }

      const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/get-referral-me`;
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const err = await response.json();
        setError(err.error || 'Erreur lors du chargement');
        return;
      }

      const result = await response.json();
      setData(result);
    } catch (e: any) {
      setError(e.message || 'Erreur inconnue');
    } finally {
      setLoading(false);
    }
  }

  return { data, loading, error, refetch: fetchReferral };
}
